export default __webpack_public_path__ + "static/media/mainLogoBlur.1c13ee8b.png";